import { REFERRAL_INTENT_SESSION_STORAGE_KEY } from '#app/constants/referral.js';
import { sessionStorage } from '#app/services/storage.js';
import { parseJson } from '#app/utilities/parseJson.js';
import { safeStringify } from '@contra/utilities/safeStringify';
import { useState } from 'react';

export type ReferralIntentStorage = {
  id: string;
  intentAction: null | string;
  referrer: null | {
    displayUsername: string;
    firstName: string;
    lastName: string;
  };
};

type UsePersistedReferralIntent = {
  referralIntent: null | ReferralIntentStorage;
  setReferralIntent: (updatedReferralIntent: ReferralIntentStorage) => void;
};

export const usePersistedReferralIntent = (): UsePersistedReferralIntent => {
  const initialState = sessionStorage.getItem(
    REFERRAL_INTENT_SESSION_STORAGE_KEY,
  );
  const [referralIntent, setReferralIntent] =
    useState<null | ReferralIntentStorage>(() =>
      initialState ? parseJson(initialState) : null,
    );

  const persistReferralIntent = (
    updatedReferralIntent: ReferralIntentStorage,
  ) => {
    sessionStorage.setItem(
      REFERRAL_INTENT_SESSION_STORAGE_KEY,
      safeStringify(updatedReferralIntent),
    );
    setReferralIntent(referralIntent);
  };

  return {
    referralIntent,
    setReferralIntent: persistReferralIntent,
  };
};
